// extracted by mini-css-extract-plugin
export default {"inProgress":"Tdt2PoBAY8Gtc9bajVgG"};